"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(require("./FormLabel"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/FormLabel/index.js
 ** module id = 53
 ** module chunks = 0
 **/